// Template catalogue: family/occasion filters and colour dots.
// The page is complete without this file; it only adds these controls.
(() => {
function init(root) {
  const cards = [...root.querySelectorAll('.ag-tc-card')];
  const count = root.querySelector('[data-tc-count]');
  const empty = root.querySelector('[data-tc-empty]');
  const valid = (attribute, value) =>
    !value || !!root.querySelector(`[${attribute}="${CSS.escape(value)}"]`);

  // ?type=moon-phase&occasion=gift keeps a filtered view shareable.
  const params = new URLSearchParams(location.search);
  const state = { family: params.get('type') || '', occasion: params.get('occasion') || '' };
  if (!valid('data-tc-family', state.family)) state.family = '';
  if (!valid('data-tc-occasion', state.occasion)) state.occasion = '';

  const matches = (card, family, occasion) =>
    (!family || card.dataset.family === family) &&
    (!occasion || card.dataset.occasions.split(' ').includes(occasion));
  const total = (family, occasion) => cards.filter((card) => matches(card, family, occasion)).length;

  const helper = root.querySelector('[data-tc-helper]');

  let rendered = false;
  function render() {
    let shown = 0;
    for (const card of cards) {
      const match = matches(card, state.family, state.occasion);
      // After a filter change, posters coming into view settle in (CSS, a
      // short stagger); the first render leaves the page as it loaded.
      // A poster still waiting for its scroll reveal gets that one instead.
      if (rendered && match && card.hidden && !card.classList.contains('ag-reveal-wait')) {
        card.classList.remove('ag-tc-card--in');
        card.style.setProperty('--tc-i', String(Math.min(shown, 8)));
        void card.offsetWidth;
        card.classList.add('ag-tc-card--in');
      }
      card.hidden = !match;
      if (match) shown += 1;
      // Even orders for posters leave the odd slot after the third for the helper.
      card.style.order = String(match ? shown * 2 : 0);
    }
    if (helper) {
      helper.hidden = !!state.family || shown < 4;
      helper.style.order = '7';
    }
    count.textContent = `${shown} ${shown === 1 ? count.dataset.wordOne : count.dataset.word}`;
    empty.hidden = shown > 0;
    // A chip that would show nothing with the other filter is disabled, not a dead end.
    for (const chip of root.querySelectorAll('[data-tc-family]')) {
      chip.setAttribute('aria-pressed', String(chip.dataset.tcFamily === state.family));
      chip.disabled = !total(chip.dataset.tcFamily, state.occasion);
    }
    for (const chip of root.querySelectorAll('[data-tc-occasion]')) {
      chip.setAttribute('aria-pressed', String(chip.dataset.tcOccasion === state.occasion));
      chip.disabled = !total(state.family, chip.dataset.tcOccasion);
    }
    rendered = true;
  }

  function remember() {
    const url = new URL(location.href);
    for (const [key, value] of [['type', state.family], ['occasion', state.occasion]])
      value ? url.searchParams.set(key, value) : url.searchParams.delete(key);
    history.replaceState(history.state, '', url);
  }

  // A colour dot shows that prerendered colour and opens the editor on it.
  function choose(dot) {
    const card = dot.closest('.ag-tc-card');
    const image = card.querySelector('[data-tc-image]');
    const link = card.querySelector('[data-tc-link]');
    if (image.getAttribute('src') !== dot.dataset.src) {
      image.src = dot.dataset.src;
      image.alt = `${card.querySelector('.ag-tc-name span').textContent}, ${dot.dataset.paper}`;
    }
    const url = new URL(link.href, location.href);
    url.searchParams.set('template', dot.dataset.template);
    link.href = url.pathname + url.search;
    for (const other of card.querySelectorAll('.ag-tc-dot'))
      other.setAttribute('aria-pressed', String(other === dot));
  }

  // Links anywhere on the page ("Choose a Moon design", a story, the helper)
  // filter in place instead of reloading; their href is the no-script fallback.
  root.tcApply = (family, occasion) => {
    if (family !== undefined && valid('data-tc-family', family)) state.family = family;
    if (occasion !== undefined && valid('data-tc-occasion', occasion)) state.occasion = occasion;
    render();
    remember();
    const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  };

  root.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-tc-family], [data-tc-occasion]');
    if (chip) {
      if (chip.disabled) return;
      if ('tcFamily' in chip.dataset) state.family = chip.dataset.tcFamily;
      else state.occasion = chip.dataset.tcOccasion;
      render();
      remember();
      return;
    }
    const dot = event.target.closest('.ag-tc-dot');
    if (dot) choose(dot);
  });
  // Hovering a dot previews it; the images are small prerenders, so this is instant.
  root.addEventListener(
    'pointerover',
    (event) => {
      const dot = event.target.closest('.ag-tc-dot');
      if (dot && event.pointerType === 'mouse') choose(dot);
    },
    { passive: true }
  );

  render();
}

for (const root of document.querySelectorAll('[data-tc-root]')) init(root);
// `data-tc-set-family` / `data-tc-set-occasion` apply to the page's catalogue;
// an attribute left out keeps that filter, an empty one clears it.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-tc-set-family], [data-tc-set-occasion]');
  const root = link && document.querySelector('[data-tc-root]');
  if (!root?.tcApply || event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
  event.preventDefault();
  root.tcApply(
    link.hasAttribute('data-tc-set-family') ? link.dataset.tcSetFamily : undefined,
    link.hasAttribute('data-tc-set-occasion') ? link.dataset.tcSetOccasion : undefined
  );
});
// The theme editor re-renders the section after every setting change; its
// scripts do not run again, so bind the new markup here.
document.addEventListener(
  'shopify:section:load',
  (event) => {
    const root = event.target.querySelector('[data-tc-root]');
    if (root) init(root);
  },
  { passive: true }
);
})();
